import videojs from 'video.js';
import Player from 'video.js/dist/types/player';
import { BaseRenderer, View } from '@/modules/core/ui/renderers/BaseRenderer';
import { VideoType } from '@/modules/core/app/constants/VideoType';

export class VideoPlayerPresenter extends BaseRenderer {
  player!: Player;
  url!: string;
  mediaType!: VideoType;

  constructor(view: View, url: string, mediaType: VideoType = VideoType.MP4) {
    super(view);
    this.url = url;
    this.mediaType = mediaType;
  }

  initialize(): void {
    this.player = videojs(this.view!.$refs.videoPlayer, {
      fluid: true,
      controls: false,
      autoplay: false,
      sources: [
        {
          src: this.url,
          type: this.mediaType
        }
      ]
    });
  }

  play(): void {
    this.player.play();
  }

  pause(): void {
    this.player.pause();
  }

  isPaused(): boolean {
    return this.player.paused();
  }

  resetVideo(): void {
    this.setTime(0);
  }

  replayVideo(): void {
    this.resetVideo();
    this.play();
  }

  togglePause(): void {
    if (this.isPaused()) {
      this.play();
    } else {
      this.pause();
    }
  }

  setTime(time: number): void {
    this.player.currentTime(time);
  }

  setPauseListener(cb: () => void): void {
    this.player.on('pause', cb);
  }

  setPoster(url: string): void {
    this.player.poster(url);
  }

  setControls(hasControls: boolean): void {
    this.player.controls(hasControls);
  }

  setPlayListener(cb: () => void): void {
    this.player.on('play', cb);
  }

  setTimeUpdateListener(cb: (player: Player) => void): void {
    this.player.on('timeupdate', () => cb(this.player));
  }

  setEndedListener(cb: () => void): void {
    this.player.on('ended', cb);
  }
}
